exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tags__tag__22NL0{margin-right:15px;margin-bottom:15px;border:1px solid -wix-colors-textColor;border-radius:15px}.tags__tag__22NL0.tags__mobile__rikMp{color:#000}", "", {"version":3,"sources":["/home/builduser/agent43/work/c8e02a04a4ed599f/src/widget/components/tags/src/widget/components/tags/tags.styl","/home/builduser/agent43/work/c8e02a04a4ed599f/src/widget/components/tags/tags.styl"],"names":[],"mappings":"AAEA,kBACE,kBAAA,mBACA,uCACA,kBACA,CAEA,sCACE,UAAA,CCDH","file":"tags.styl","sourcesContent":["@import '~shared/styles/colors-static.styl'\n\n.tag\n  margin-right 15px\n  margin-bottom 15px\n  border 1px solid -wix-colors-textColor\n  border-radius 15px\n\n  &.mobile\n    color color-static-text-main\n",".tag {\n  margin-right: 15px;\n  margin-bottom: 15px;\n  border: 1px solid -wix-colors-textColor;\n  border-radius: 15px;\n}\n.tag.mobile {\n  color: #000;\n}\n/*# sourceMappingURL=src/widget/components/tags/tags.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"tag": "tags__tag__22NL0",
	"mobile": "tags__mobile__rikMp"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/tags/tags.styl
// module id = 1712
// module chunks = 1 2